<template>
  <div class="order-confirmation-purchase-document">
    <h1>{{ $t("page.order.confirmation.step.purchasedocument") }}</h1>
    <h2>{{ $t("page.order.confirmation.purchasedocument.info") }}</h2>

    <div
      class="upload-area flex-center"
      :class="{
        'outline-primary': !!dragging
      }"
      @keydown.enter.prevent
      @dragenter.stop.prevent="dragging = true"
      @dragover.stop.prevent="dragging = true"
      @dragend.prevent.stop="dragging = false"
      @dragleave.stop.prevent="dragging = false"
      @drop.stop.prevent="handleAddedFile($event.dataTransfer.files[0])"
    >
      <input
        id="purchase-document-file"
        type="file"
        class="d-none"
        @change="onFileSelected"
        ref="input"
        accept="application/pdf"
      />
      <v-button white class="no-border upload-area__upload-btn" @click.stop.prevent="openDialog">
        <img src="~@/assets/icons/icon-paperclip.svg" class="paperclip-icon" />
        {{ $t("page.order.confirmation.uploadpdf") }}
      </v-button>

      <v-button
        v-if="purchaseDocument"
        id="purchase-document-remove"
        primary
        @click="$emit('update:purchaseDocument', null)"
        class="close-button"
      >
        <img src="~@/assets/icons/icon-popup-close-white.svg" />
      </v-button>
      <div id="purchase-document-filename" class="upload-area__filename" v-if="purchaseDocument">
        {{ purchaseDocument.name }}
      </div>
    </div>

    <div class="mt-50 text-right order-confirmation-popup__footer">
      <v-button class="mr-10 back-button" @click="$emit('cancel')" white>
        <img src="~@/assets/icons/arrow-right-blue.svg" class="icon-left" />
        {{ $t("common.back") }}
      </v-button>

      <v-button id="approve-purchase-button" primary @click="$emit('continue')" :disabled="!purchaseDocument">
        {{ $t("common.continue") }}
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.28859 9.88047L5.16859 6.00047L1.28859 2.12047C0.898594 1.73047 0.898594 1.10047 1.28859 0.710469C1.67859 0.320469 2.30859 0.320469 2.69859 0.710469L7.28859 5.30047C7.67859 5.69047 7.67859 6.32047 7.28859 6.71047L2.69859 11.3005C2.30859 11.6905 1.67859 11.6905 1.28859 11.3005C0.908594 10.9105 0.898594 10.2705 1.28859 9.88047Z"
            fill="#FDFDFD"
          />
        </svg>
      </v-button>
    </div>
  </div>
</template>

<script>
import { VButton } from "shared";
export default {
  components: {
    VButton
  },
  data() {
    return {
      dragging: false
    };
  },
  props: {
    purchaseDocument: {
      type: File,
      default: null
    }
  },
  methods: {
    openDialog() {
      this.$refs.input.click();
    },
    onFileSelected() {
      this.$emit("update:purchaseDocument", this.$refs.input.files[0]);
      this.$refs.input.value = null;
    },
    handleAddedFile(file) {
      this.dragging = false;
      this.$emit("update:purchaseDocument", file);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
h1 {
  font-size: 24px;
  line-height: 26px;
  margin: 30px 0 5px 0;
  letter-spacing: 0.8px;
}

.upload-area {
  border: 1px solid $color-grey;
  background: $color-faint-grey;
  width: 100%;
  min-height: 375px;
  margin: 23px 0 0 0;
  position: relative;
  &__filename {
    position: absolute;
    bottom: 40px;
    left: 0;
    right: 0;
    text-align: center;
  }
  &__upload-btn {
    background: none;
    font-size: 13px;
    letter-spacing: 0.2px;
    margin: -27px 0 0 -9px;
  }
}

.back-button {
  padding-left: 35px;
  padding-right: 15px;
  img {
    width: 10px;
    height: 10px;
    transform: rotate(180deg);
    margin-top: -1px !important;
  }
}

.close-button {
  padding: 4px;
  border-radius: 50%;
  position: absolute;
  right: -16px;
  top: -16px;
  img {
    margin: 0 !important;
  }
}

.paperclip-icon {
  margin: 0 10px 0 0 !important;
}
</style>
